import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { AuthService } from '@core/auth'

@Component({
  selector: 'root',
  imports: [RouterOutlet],
  host: { class: 'flex flex-1 flex-col' },
  template: `
    @if (auth.isLoggingOut()) {
      <p
        role="status"
        class="sr-only">
        Cerrando sesión…
      </p>
    } @else {
      <router-outlet />
    }
  `
})
export class App {
  protected readonly auth = inject(AuthService)
}
